import React, { useState } from 'react';
import cadillacXTS from '../assets/images/Cadillac XTS.png'; // Imagen del carro
import { MdAirlineSeatReclineNormal, MdLuggage } from 'react-icons/md';

const InteractiveCard = () => {
  const [showReservationForm, setShowReservationForm] = useState(false);

  const handleViewDetails = () => {
    setShowReservationForm(true);
  };

  const handleCloseForm = () => {
    setShowReservationForm(false);
  };

  return (
    <div
      style={{
        width: '100%',
        maxWidth: '400px',
        backgroundColor: '#fff',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        padding: '20px',
        textAlign: 'center',
        fontFamily: "'Arial', sans-serif",
        margin: '20px auto',
      }}
    >
      {/* Imagen del vehículo */}
      <img
        src={cadillacXTS}
        alt="Cadillac XTS"
        style={{
          width: '100%',
          height: 'auto',
          borderRadius: '8px',
          objectFit: 'cover',
        }}
      />

      {/* Información del vehículo */}
      <h2 style={{ fontSize: '1.8rem', color: '#19365C', margin: '15px 0' }}>CADILLAC XTS</h2>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-around',
          padding: '10px 0',
          borderTop: '1px solid #ddd',
          borderBottom: '1px solid #ddd',
          marginBottom: '15px',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <MdAirlineSeatReclineNormal style={{ fontSize: '2rem', color: '#19365C' }} />
          <p style={{ margin: '5px 0', fontSize: '0.9rem' }}>Max: 4 Passengers</p>
        </div>
        <div style={{ textAlign: 'center' }}>
          <MdLuggage style={{ fontSize: '2rem', color: '#19365C' }} />
          <p style={{ margin: '5px 0', fontSize: '0.9rem' }}>Max: 4 Suitcases</p>
        </div>
      </div>

      {/* Botón de detalles */}
      {!showReservationForm && (
        <button
          onClick={handleViewDetails}
          style={{
            backgroundColor: '#19365C',
            color: '#fff',
            border: 'none',
            padding: '10px 20px',
            fontSize: '1rem',
            borderRadius: '5px',
            cursor: 'pointer',
            fontWeight: 'bold',
            width: '100%',
            transition: 'background-color 0.3s ease',
          }}
        >
          View Details →
        </button>
      )}

      {/* Formulario de reserva */}
      {showReservationForm && (
        <div
          style={{
            width: '100%',
            backgroundColor: '#f4f4f4',
            border: '2px solid #19365C',
            borderRadius: '10px',
            padding: '20px',
            marginTop: '15px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          }}
        >
          <h3 style={{ color: '#19365C', marginBottom: '10px' }}>Reservation Form</h3>
          <iframe
            src="https://bookridesonline.com/book/?dbaid=a0QxYhwasvAMbYgsQXPG0g%3d%3d"
            title="Reservation Form"
            style={{
              width: '100%',
              height: '250px',
              border: 'none',
              borderRadius: '5px',
              marginBottom: '10px',
            }}
          ></iframe>
          <button
            onClick={handleCloseForm}
            style={{
              backgroundColor: '#19365C',
              color: '#fff',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '5px',
              fontSize: '1rem',
              cursor: 'pointer',
              fontWeight: 'bold',
              width: '100%',
              transition: 'background-color 0.3s ease',
            }}
          >
            Close Form
          </button>
        </div>
      )}
    </div>
  );
};

export default InteractiveCard;
